import React from 'react'
import { Link } from 'react-router-dom'
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { map } from 'lodash'
import PropTypes from 'prop-types'
function NavList({ steps, currentStep }) {
  return (
    <List>
      {map(steps, (step, key) => (
        <ListItemButton
          key={key}
          className={step.progress === step.maxProgress ? 'Mui-checked' : ''}
          component={Link}
          to={step.to}
          selected={step.name === currentStep?.name}
          disabled={step.disabled}
          sx={({ palette }) => ({
            '&:hover': {
              backgroundColor: 'transparent',
              '&:before': {
                content: '" "',
                height: '36px',
                width: '4px',
                background: palette.common.brand,
              },
            },
            '&.Mui-checked': {
              color: palette.common.black,
            },
            '&.Mui-selected': {
              color: palette.common.black,
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              '&:before': {
                content: '" "',
                height: '36px',
                width: '4px',
                background: palette.common.brand,
              },
            },
          })}
        >
          <ListItemIcon>
            {step.progress === step.maxProgress ? step.checkedIcon : step.icon}
          </ListItemIcon>
          <ListItemText primary={step.label} />
        </ListItemButton>
      ))}
    </List>
  )
}

NavList.propTypes = {
  steps: PropTypes.array,
  currentStep: PropTypes.object,
}
NavList.defaultProps = {
  steps: [],
  currentStep: {},
}
export default NavList
